import { forwardRef } from "react";
import { useField } from "formik";
import { Password } from "primereact/password";

import { Props } from "./types";

export const PasswordInputField = forwardRef<HTMLInputElement, Props>(
  ({ id, label, ...props }: Props, ref) => {
    const [field, meta] = useField(props.name);

    return (
      <span className="gap-2 flex flex-column" id={id}>
        <Password inputRef={ref} placeholder={label} {...props} {...field} />
        {meta.error && meta.touched && (
          <small className="text-red-500 text-sm ml-1">{meta.error}</small>
        )}
      </span>
    );
  },
);
